import type Luminary from '@lumen5/luminary';

import type { Tool } from '../tools/Tool';

import { CaptureSceneTool } from './CaptureSceneTool';
import { EditHtmlAssetTool } from './EditHtmlAssetTool';
import { ListSceneDesignsTool } from './ListSceneDesignsTool';
import { LoadHtmlDesignSkillTool } from './LoadHtmlDesignSkillTool';
import { PreviewSceneDesignsTool } from './PreviewSceneDesignsTool';
import { SetSceneDurationTool } from './SetSceneDurationTool';
import { WriteHtmlAssetTool } from './WriteHtmlAssetTool';

import type { AppDispatch } from 'js/src/libs/RootState';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

/**
 * The design agent's toolset, shared by every surface that runs a design session: the standalone
 * HtmlDesignRootAgent and Toolbox's design-subagent tools. The tools that act on a design resolve
 * their target (sceneId, assetId) from Redux by conversation id, so the same instances work for any
 * session that registers its conversation via setHtmlDesignTarget.
 */
export function buildHtmlDesignTools(
    luminary: Luminary,
    dispatch: AppDispatch,
    getState: GetRootState,
): Tool[] {
    return [
        new WriteHtmlAssetTool({ luminary, dispatch, getState }),
        new EditHtmlAssetTool({ luminary, dispatch, getState }),
        new CaptureSceneTool({ luminary, dispatch, getState }),
        new LoadHtmlDesignSkillTool({ luminary, dispatch, getState }),
        new SetSceneDurationTool({ luminary, dispatch, getState }),
        new ListSceneDesignsTool({ luminary, dispatch, getState }),
        new PreviewSceneDesignsTool({ luminary, dispatch, getState }),
    ];
}
